/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../../../../shared/AOForm/components/InputText/InputText';
import { decimal, formatCurrency, percentage } from '../../../../utils/ValidationUtils';

export default class InputWithPrefixSuffix extends React.Component {
  constructor(props) {
    super(props);

    [
      'unformattedCurrency',
      'handleValueDidChange',
      'handleBlurAction',
    ].forEach((fn) => this[fn] = this[fn].bind(this));
    this.setupData(props)
  }

  unformattedCurrency = (value) => {
    /*
    * check if component has prefix props, formatted data to normal number (remove comma).
    */

    const { prefix } = this.props;
    if (prefix) {
      return value ? decimal(value.replace(/,/g, '')) : value
    } else {
      return value
    }
  };

  handleValueDidChange = (questionRel, value, event) => {
    /*
    * callback the onChange action.
    */

    let newValue = value;
    const { onChangeAction, formatAction, isPercentage } = this.props;
    if (formatAction) {
      newValue = formatAction(value)
    }
    if (isPercentage && !percentage(newValue)) {
      return false
    }
    onChangeAction && onChangeAction(questionRel, this.unformattedCurrency(newValue), event)
  };

  handleBlurAction = (rel, val)=> {
    /*
    * callback the onBlur action.
    */

    const { onBlurAction, content } = this.props;
    const { questionRel } = content;
    onBlurAction && onBlurAction(questionRel, val);
  };

  setupData(props) {
    /*
    * setup component required props.
    */

    const {
      prefix,
      suffix,
      maxLength,
      isNumber, //decide to UI style (input field width)
      isPercentage, //decide to input field with "%" suffix
    } = props;

    this.dataType = 'text';
    if ((isNumber || isPercentage) && !prefix) this.dataType = 'tel';

    this.overlapLabel = {
      labelContent: !!prefix ? prefix : !!suffix ? suffix : null,
      float: !!prefix ? 'left' : !!suffix ? 'right': null
    };
    this.maxLengthValue = maxLength===null ? 0 : maxLength;
    this.numberClz = isNumber ? 'number-field' : '';
    if (!!prefix) this.numberClz = '';
  }

  componentWillReceiveProps(nextProps) {
    this.setupData(nextProps)
  }

  render() {
    const {
      content,
      disabled,
      prefix,
    } = this.props;

    if (!!prefix) {
      content.textValue = formatCurrency(content.textValue);
    }

    return (
      <div className="reserved-item-input">
          <InputText
            handleTextChange={ this.handleValueDidChange }
            content={ content }
            overlapLabel={ this.overlapLabel }
            disabled={ disabled }
            maxLength={ this.maxLengthValue }
            FormGroupClassName={ this.numberClz }
            handleBlurAction={ this.handleBlurAction }
            type={ this.dataType }
          />
      </div>
    )
  }
};

InputWithPrefixSuffix.propTypes = {
  onChangeAction: PropTypes.func,
  content: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  maxLength: PropTypes.number,
  isNumber: PropTypes.bool,
  formatAction: PropTypes.func,
  isPercentage: PropTypes.bool,
  onBlurAction: PropTypes.func
};

InputWithPrefixSuffix.defaultProps = {
  content: {},
  isNumber: false,
  isPercentage: false
};


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/InputWithPrefixSuffix/index.js